import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import PhonelinkEraseOutlinedIcon from '@mui/icons-material/PhonelinkEraseOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import AppBlockingIcon from '@mui/icons-material/AppBlocking';
import { DeviceAction, IActions } from '../../types';
import { ReactComponent as SimActiveIcon } from '../../SimActive.svg';
import { ReactComponent as SimInactiveIcon } from '../../SimInactive.svg';

export const getActions = (actions: IActions) => [
  {
    icon: <LoginIcon />,
    title: 'Assign to Program',
    devicesIds: actions[DeviceAction.Assign],
    action: DeviceAction.Assign,
  },
  {
    icon: <LogoutIcon />,
    title: 'Unassign from Program',
    devicesIds: actions[DeviceAction.Unassign],
    action: DeviceAction.Unassign,
  },
  {
    icon: <PersonRemoveIcon />,
    title: 'Unregister from Patient',
    devicesIds: actions[DeviceAction.Unregister],
    action: DeviceAction.Unregister,
  },
  {
    icon: <KeyboardReturnOutlinedIcon />,
    title: 'Mark as Returned',
    devicesIds: actions[DeviceAction.MarkAsReturned],
    action: DeviceAction.MarkAsReturned,
  },
  {
    icon: <PhonelinkEraseOutlinedIcon />,
    title: 'Mark as Lost',
    devicesIds: actions[DeviceAction.MarkAsLost],
    action: DeviceAction.MarkAsLost,
  },
  {
    icon: <AppBlockingIcon />,
    title: 'Mark as Defective',
    devicesIds: actions[DeviceAction.MarkAsDefective],
    action: DeviceAction.MarkAsDefective,
  },
  {
    icon: <LoginIcon />,
    title: 'Mark as Available',
    devicesIds: actions[DeviceAction.MarkAsAvailable],
    action: DeviceAction.MarkAsAvailable,
  },
  {
    icon: <SimActiveIcon />,
    title: 'Activate SIM',
    devicesIds: actions[DeviceAction.ActivateSim],
    action: DeviceAction.ActivateSim,
  },
  {
    icon: <SimInactiveIcon />,
    title: 'Deactivate SIM',
    devicesIds: actions[DeviceAction.DeactivateSim],
    action: DeviceAction.DeactivateSim,
  },
  {
    icon: <DeleteIcon />,
    title: 'Delete',
    devicesIds: actions[DeviceAction.Delete],
    action: DeviceAction.Delete,
  },
];

export default {};
